import * as yup from "yup";

const schema = yup.object().shape({
  subject: yup
    .string()
    .required()
    .matches(/^(?!\s+$).+/, "Please provide valid values for Subject")
    .label("Subject"),
  email: yup.string().email().required().label("Email"),
  message: yup
    .string()
    .required()
    .matches(/^(?!\s+$).+/, "Please provide valid values for Message")
    .label("Message"),
});

export default schema;
